export default __webpack_public_path__ + "987d62bea7e91ac97a64ba177176b49e.png";